package team.platforma.chat_data.di

import org.koin.dsl.module

actual val chatDatabaseModule = module { }